import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../../../shared/shared.module';
import { civilityOptions } from '../../../../../shared/utils/data/etablissments-data';
import { AuthService } from '../../../../../services/auth.service';
import { FlagService } from '../../../../../shared/services/flag.service';
import { CandidatService } from '../../../../../services/candidat.service';
import { FlagType } from '../../../../../shared/utils/enums';
import { title } from 'process';

@Component({
  selector: 'app-add-candidat-step',
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: './add-candidat-step.component.html',
  styleUrl: './add-candidat-step.component.scss'
})
export class AddCandidatStepComponent implements OnInit {
  @Input() form!: FormGroup;
  @Input() loading = false;
  @Output() onValidated = new EventEmitter<any>();
  @Output() nextStepEmitter = new EventEmitter<number>();

  civilityOptions = civilityOptions;
  get passwordFormField() {
    return this.form.get('password')?.value;
  }

  constructor(public authService: AuthService,    
    private candidatService: CandidatService,
    private flag: FlagService
) {}

  ngOnInit(): void {
    //if (this.form) {
    //  this.form.valueChanges.subscribe(() => {
    //    this.onValidated.emit(this.form.valid);
    //  });
    // }
  }

  nextStep(): void {
    if (this.form.valid) {
      this.loading = true;
      const body = {
        firstName: this.form.get('firstName')?.value,
        lastName: this.form.get('lastName')?.value,
        email: this.form.get('email')?.value,
        title: this.form.get('prefixe')?.value,
        source: 'AGENCY_CANDIDATE',
        kind: 'CANDIDAT'
      };
      this.authService.signupAgency(body).subscribe({
        next: (res) => {
          if (res.status == 'success') {
            // this.submit(res.data);
            this.flag.displayFlag('Candidat créé avec succès !', FlagType.success);
            this.nextStepEmitter.emit(res.data.collary_id);    
          }
        },
        error: (e) => {
          this.loading = false;
          // Privilege the backend message (e.g. "Email is already in use!"), then fall back.
          const backendMsg = (e?.error?.message || '').replace(/^Error:\s*/i, '').trim();
          this.flag.displayFlag(backendMsg || 'Erreur lors de la création du candidat.', FlagType.error);
        },
        complete: () => this.loading = false
      });
    }
  }

  get isFormDisabled(): boolean {
    return this.form.invalid || this.loading;
  }

  private submit(finalBody : any = {}): void {
    this.loading = true;
    const body = {
      civility: this.form.get('prefixe')?.value,
      lastname: finalBody.last_name,
      firstname: finalBody.first_name,
      mailadress: finalBody.email,
      fullname: finalBody.last_name + ' ' + finalBody.first_name
    };
    this.candidatService.upadateCandidat(body, finalBody.collary_id).subscribe({
      next: (response) => {
        this.flag.displayFlag('Candidat créé avec succès !', FlagType.success);
        this.nextStepEmitter.emit();
      },
      error: (error) => {
        this.flag.displayFlag('Erreur lors de la création', FlagType.error, 2);
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      }
    });
  }
}
